export default "__VITE_ASSET__DXwrIp2t__"